import React from 'react';
import { useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

export const AccountSetupInvalidRequest = () => {
    const translate = useTranslate();
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography className={classes.title} gutterBottom>
                {translate(
                    'apihub.account_setup.notifications.invalid_activation_link'
                )}
            </Typography>
            <Typography gutterBottom>
                {translate(
                    'apihub.account_setup.notifications.register_error'
                )}
            </Typography>
            <Typography gutterBottom>
                {translate(
                    'apihub.account_setup.notifications.contact_customer_service'
                )}
            </Typography>
            <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/login"
                className={classes.button}
            >
                {translate('apihub.account_setup.actions.return_to_login')}
            </Button>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        root: {},
        title: {
            color: theme.palette.error.main,
        },
        button: {
            marginTop: '2rem'
        },
    }),
    {
        name: 'Layer7AccountSetupInvalidRequest',
    }
);
